module.exports = __webpack_public_path__ + "static/media/logoImage.6d6a58e8.png";


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/assets/images/logoImage.png
// module id = ../lib/egov-ui-kit/assets/images/logoImage.png
// module chunks = 504